var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg014Smile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98C26.629,123.333,0,187.62,0,256 s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512c46.813,0,92.617-12.758,132.462-36.893 c9.447-5.724,12.467-18.022,6.744-27.469c-5.724-9.449-18.023-12.468-27.469-6.744C334.144,461.244,295.505,472,256,472 c-119.103,0-216-96.897-216-216S136.897,40,256,40s216,96.897,216,216c0,42.589-12.665,84.044-36.626,119.884 c-6.139,9.182-3.672,21.603,5.51,27.742c9.184,6.139,21.604,3.672,27.742-5.51C497.002,355.674,512,306.53,512,256 C512,187.62,485.371,123.333,437.02,74.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,288H156c-11.046,0-20,8.954-20,20c0,66.168,53.832,120,120,120s120-53.832,120-120C376,296.954,367.046,288,356,288z  M256,388c-37.209,0-68.567-25.534-77.469-60h154.938C324.566,362.466,293.209,388,256,388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,196h-38.761l11.072-19.868c5.377-9.648,1.913-21.829-7.735-27.206c-9.651-5.379-21.831-1.913-27.206,7.735 l-27.642,49.604c-3.451,6.194-3.365,13.753,0.227,19.867c3.593,6.113,10.153,9.868,17.244,9.868H380c11.046,0,20-8.954,20-20 S391.046,196,380,196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.471,206.264l-27.642-49.604c-5.377-9.649-17.557-13.111-27.206-7.735c-9.648,5.377-13.112,17.558-7.735,27.206 L166.96,196h-38.761c-11.046,0-20,8.954-20,20s8.954,20,20,20H201c7.091,0,13.651-3.755,17.244-9.869 C221.836,220.017,221.922,212.458,218.471,206.264z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg014Smile);
export default __webpack_public_path__ + "static/media/014-smile.bacb893dad8285edba15b248c470eeb0.svg";
export { ForwardRef as ReactComponent };